
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chapters/more-like/[slug]",
      function () {
        return require("private-next-pages/chapters/more-like/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chapters/more-like/[slug]"])
      });
    }
  